import { default as gql } from 'graphql-tag';

export const usersQuery = gql`
  query users($filter: UserInput, $objectId: Int, $limit: Int, $onlyApprovers: Boolean, $onlyExecutors: Boolean, $isDeleted: Boolean) {
    users(filter: $filter, objectId: $objectId, limit: $limit, onlyApprovers: $onlyApprovers, onlyExecutors: $onlyExecutors, isDeleted: $isDeleted) {
      id
      name
      surname
      fullName
      role
      email
      username
      language
      notify
      accessPricing
      manageEvents
      manageWarehouses
      manageRepairs
      manageRepairBudget
      issueTaskExecutor
      canApproveRecommendations
      isDeleted
      userObjects {
        id
        objectId
        object {
          id
          name
        }
        userId
      }
    }
  }
`;
export const userQuery = gql`
  query user($id: Int) {
    user(id: $id) {
      id
      name
      surname
      fullName
      role
      email
      username
      language
      notify
      accessPricing
      manageEvents
      manageWarehouses
      manageRepairs
      manageRepairBudget
      issueTaskExecutor
      canApproveRecommendations
      isDeleted
      userObjects {
        id
        objectId
        object {
          id
          name
        }
        userId
      }
    }
  }
`;

export const createUser = gql`
  mutation createUser($user: UserInput!) {
    createUser(user: $user) {
      id
      name
      surname
      fullName
      role
      email
      username
      language
      notify
      userObjects {
        id
        objectId
        object {
          id
          name
        }
        userId
      }
    }
  }
`;

export const deleteUser = gql`
  mutation deleteUser($id: Int!) {
    deleteUser(id: $id) {
      id
    }
  }
`;

export const updateUser = gql`
  mutation updateUser($user: UserInput!) {
    updateUser(user: $user) {
      id
      name
      surname
      fullName
      role
      email
      username
      language
      notify
      userObjects {
        id
        objectId
        object {
          id
          name
        }
        userId
      }
    }
  }
`;

export const changePassword = gql`
  mutation changePassword($userId: Int!, $oldPassword: String, $newPassword: String!) {
    changePassword(userId: $userId, oldPassword: $oldPassword, newPassword: $newPassword) {
      success
    }
  }
`;

export const userUpsertFilter = gql`
  fragment userFragment on User {
    id
    name
    surname
    role
    email
    username
    password
    language
    notify
    accessPricing
    manageEvents
    manageWarehouses
    manageRepairs
    manageRepairBudget
    issueTaskExecutor
    canApproveRecommendations
    isDeleted
  }
`;

export const deleteUserObject = gql`
  mutation deleteUserObject($id: Int!) {
    deleteUserObject(id: $id) {
      id
    }
  }
`;

export const upsertUserObject = gql`
  mutation upsertUserObject($userObject: UserObjectInput!) {
    upsertUserObject(userObject: $userObject) {
      id
      userId
      objectId
    }
  }
`;

export const userObjectUpsertFilter = gql`
  fragment userObjectUpsertFilter on UserObject {
    userId
    objectId
  }
`;

export const userUsernameAvailQuery = gql`
  query userUsernameAvailable($username: String) {
    userUsernameAvailable(username: $username)
  }
`;

export const clientAndAvailableAddonsQuery = gql`
  query availableAddons($userId: Int, $clientId: Int!){
    availableAddons(userId: $userId, clientId: $clientId){
      id,
      keyword
    }
    client(id: $clientId) {
      id
      name
      namespace
      languages
    }
  }
`;